module.exports = __webpack_public_path__ + "static/media/alert_client.d0d65fdf.svg";